// In-memory access token + localStorage refresh token store for the
// REST auth migration.  Replaces ``legacy-sdk/core/storage.ts`` for the
// dashboard's auth surface.  Other module-level constants live next to
// the helpers so the module remains tree-shakeable.

import { LOCAL_STORAGE_EXISTS } from '../legacy-sdk/constants';
import { isLikelyJwt } from '../legacy-sdk/helpers';

export const NUXNODE_REFRESH_TOKEN_KEY = 'nuxnodeRefreshToken';

let accessTokenHotbox: string | null = null;
let refreshTokenCache: string | null = LOCAL_STORAGE_EXISTS ? readPersistedRefreshToken() : null;

function readPersistedRefreshToken(): string | null {
  if (!LOCAL_STORAGE_EXISTS) {
    return null;
  }

  const stored = window.localStorage.getItem(NUXNODE_REFRESH_TOKEN_KEY);

  if (isLikelyJwt(stored)) {
    return stored;
  }

  if (stored !== null) {
    window.localStorage.removeItem(NUXNODE_REFRESH_TOKEN_KEY);
  }

  return null;
}

export function getAccessToken(): string | null {
  return accessTokenHotbox;
}

export function setAccessToken(token: string | null): void {
  if (token !== null && !isLikelyJwt(token)) {
    accessTokenHotbox = null;

    return;
  }

  accessTokenHotbox = token;
}

export function getRefreshToken(): string | null {
  return refreshTokenCache;
}

export function setRefreshToken(token: string | null): void {
  if (token !== null && !isLikelyJwt(token)) {
    return;
  }

  if (LOCAL_STORAGE_EXISTS) {
    if (token) {
      window.localStorage.setItem(NUXNODE_REFRESH_TOKEN_KEY, token);
    } else {
      window.localStorage.removeItem(NUXNODE_REFRESH_TOKEN_KEY);
    }
  }

  refreshTokenCache = token;
}

export function setTokens(tokens: {
  accessToken: string | null;
  refreshToken: string | null;
}): void {
  setAccessToken(tokens.accessToken);
  setRefreshToken(tokens.refreshToken);
}

export function clearTokens(): void {
  setAccessToken(null);
  setRefreshToken(null);
}
